import { Input } from "@angular/core";
import { Component } from "@angular/core";
import * as Models from "../../service-charges.model";
import { ServiceService } from "../../chargeser.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NotifierService } from "src/app/_services/notifier.service";
import { Subject, Subscription } from "rxjs";
import { take } from "rxjs/internal/operators/take";
import { SimpleChanges } from "@angular/core";
import { debounceTime } from "rxjs/internal/operators/debounceTime";
import { MonthlyExpandService } from "../../../monthlybilling.service";
import { Output } from "@angular/core";
import { EventEmitter } from "@angular/core";
type WeeklyPaginatedService = {
  product_name: string;
  service_name: string;
  costs: { week: string; base: string | number; final: string | number }[];
  regions: {
    region: string;
    costs: { week: string; base: string | number; final: string | number }[];
    product_families: {
      name: string;
      costs: { week: string; base: string | number; final: string | number }[];
    }[];
    expanded?: boolean;
  }[];
  expanded?: boolean;
};

@Component({
  selector: "daily-component",
  templateUrl: "./daily.component.html",
  styleUrls: ["./daily.component.css"],
})
export class DailyComponent {
  @Input() monthYear: any;
  @Input() accountId: any;
  @Input() regionId: any;
  @Input() isExpandedAll: any;
  @Output() monthlyData = new EventEmitter<{
    services: any[];
    total: number;
    totser: number;
  }>();
  @Input() filteredTag: any;
  @Input() searchTerm: any;
  accountOptions: { id: number; name: string }[] = [];
  market_currentPage = 1;
  market_selectedPageSize: any;
  market_totactiveser: any = 0;

  selectedAccountIds: any = [];

  breakpoints = {
    region: false,
    product_family: false,
    line_item: false,
  };

  gear: boolean = false;
  currentPage = 1;
  pageSizeOptions = [20, 50, 100];

  filterTags = false;

  headers: Models.Header[] = [
    { key: "product_code", label: "Service Name", sortable: true },
    { key: "usage", label: "Usage", sortable: false },
    { key: "base_cost", label: "Public Cost (USD)", sortable: true },
    { key: "final_cost", label: "Final Cost (USD)", sortable: true },
  ];
  prevMonth: any = [];
  services: Models.Service[] = [];
  sortKey: Models.SortableColumn = "product_code";
  // searchTerm = "";
  filter = "";
  sortDirection: "asc" | "desc" = "asc";
  total: any;
  totactiveser: any = 0;
  // filteredList: Models.Service[] = [];
  filteredList: WeeklyPaginatedService[] = [];
  funRef: any = {};
  currentMessage!: Subscription;
  // filteredTag: { accountId: string; tagKey: string; tagValue: string } | null =
  //   null;
  selectedPageSize = 20;
  usagePagination = false;
  preferencesData: {
    pageSize: number;
    wrapLines: boolean;
    usagePagination: boolean;
    visibleColumns: {
      description: boolean;
      usageQuantity: boolean;
      amountUsd: boolean;
    };
    breakpoints: {
      region: boolean;
      product_family: boolean;
      line_item: boolean;
    };
    selectedAccountIds: string[];
  } = {
    pageSize: 20,
    wrapLines: false,
    usagePagination: true,
    visibleColumns: {
      description: true,
      usageQuantity: true,
      amountUsd: true,
    },
    breakpoints: {
      region: false,
      product_family: false,
      line_item: false,
    },
    selectedAccountIds: [],
  };
  chartInstance: any;
  selectedView: any = "daily";
  weekHeaders: any[] = [];
  servicesTable: WeeklyPaginatedService[] = [];
  graphData: {
    service_name: string;
    week: string;
    final_cost: number;
    base_cost: number;
  }[];
  market_weeksObj: any;
  market_weekKeys: any;
  market_servicesTable: WeeklyPaginatedService[];
  market_filteredList: WeeklyPaginatedService[];
  market_total: any;
  graph: any = [];
  market_isExpandedAll: boolean;
  market_weekHeaders: any;
  market_searchTerm: string;

  constructor(
    public notifier: NotifierService,
    private router: Router,
    private route: ActivatedRoute,
    private service: ServiceService,
    private monthexp: MonthlyExpandService
  ) {}

  ngOnInit(): void {
    this.preferencesData.selectedAccountIds.push(this.accountId);
    this.funRef = {};

    const navigation = this.router.getCurrentNavigation();
    if (!navigation?.extras?.state) {
      this.route.queryParams.pipe(take(1)).subscribe((p): void => {
        const { open, _t, ...fp } = p;
        const b =
          p["breakup"]
            ?.toString()
            .split(",")
            .map((x: any) => x.trim())
            .filter(Boolean) || [];
        const allKeys: (keyof typeof this.preferencesData.breakpoints)[] = [
          "region",
          "product_family",
          "line_item",
        ];

        if (p["tag_key"] && p["tag_value"] && b.length) {
          // set breakpoints
          this.preferencesData.breakpoints = {
            ...this.preferencesData.breakpoints,
            ...b.reduce((acc: any, k: string) => ((acc[k] = true), acc), {}),
          };
          this.filteredTag = {
            accountId: p["account_ids"] || this.accountId,
            tagKey: p["tag_key"],
            tagValue: p["tag_value"],
          };
          this.loadPreferences(fp);
          return;
        }

        if ("mode" in p) {
          allKeys.forEach(
            (k) => (this.preferencesData.breakpoints[k] = b.includes(k))
          );
          this.loadPreferences(fp);
          return;
        }

        if (!("open" in p)) {
          this.load();
          return;
        }

        setTimeout(
          () => this.loadPreferences({ ...fp, account_ids: this.accountId }),
          100
        );
      });
    } else {
      this.load();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const changedLater = (key: "monthYear" | "accountId"): boolean =>
      !!changes[key] && !changes[key].isFirstChange();

    this.preferencesData = this.getDefaultPreferences();

    if (changes["filteredTag"] && this.filteredTag) {
      // whenever filter changes, reload with new data
      this.onTagsFiltered(this.filteredTag);
    }

    if (changedLater("monthYear") || changedLater("accountId")) {
      this.filteredTag = null;
      this.load(); // call API only when monthYear or accountId changes
    }

    if (changes["searchTerm"] || changes["tableData"]) {
      this.onSearch();
    }

    if (changes["isExpandedAll"] && !changes["isExpandedAll"].isFirstChange()) {
      if (this.isExpandedAll) {
        this.monthexp.toggleWeeklyExpand(this.servicesTable, true);
      } else {
        this.monthexp.toggleWeeklyExpand(this.servicesTable, false);
      }
      this.deepcopy();
    }
  }

  handlePageSizeChange(newPageSize: number): void {
    this.selectedPageSize = newPageSize;
    this.currentPage = 1; // reset page
  }

  deepcopy() {
    if (!this.servicesTable?.length) {
      this.filteredList = [];
      return;
    }

    this.filteredList = this.servicesTable.map((s) => ({
      product_name: s.product_name,
      service_name: s.service_name,
      costs: s.costs || [],
      expanded: s.expanded, // preserve current state
      regions: (s.regions || []).map((r: any) => ({
        region: r.region,
        costs: r.costs || [],
        expanded: r.expanded, // preserve current state
        product_families: (r.product_families || []).map((pf: any) => ({
          name: pf.name,
          costs: pf.costs || [],
        })),
      })),
    }));
  }

  private async fetchAndBind(
    query: Record<string, any>,
    pushToUrl = true
  ): Promise<void> {
    this.notifier.loading(true);

    try {
      const apiQuery = {
        ...query,
        type: this.selectedView,
      };

      await this.loadViewData(apiQuery, pushToUrl);
      this.deepcopy();
    } catch (err) {
      console.error("Error fetching data:", err);

      // Reset all table data on error
      this.servicesTable = [];
      this.weekHeaders = [];
      this.filteredList = [];
      this.total = 0;
      this.totactiveser = 0;
      this.market_totactiveser = 0;
      this.prevMonth = [];
    } finally {
      this.notifier.loading(false);
    }
  }

  weekKeys: any;
  weeksObj: any;
  private normalizeToArray(input: any): any[] {
    if (!input) return [];
    if (Array.isArray(input)) return input;
    if (typeof input === "object") return Object.values(input);
    return [];
  }

  /**
   * A service line item is treated as a marketplace item when its
   * billing_entity is anything other than "AWS".
   * ASSUMPTION: not yet confirmed against a payload where
   * market_place_services > 0 — revisit if that's wrong.
   */
  private isMarketplace(s: any): boolean {
    return (s?.billing_entity || "AWS") !== "AWS";
  }

  private async loadViewData(
    query: Record<string, any>,
    pushToUrl = true
  ): Promise<void> {
    this.notifier.loading(true);
    try {
      const { result, fullQuery } = await this.service.loadDailyBilling(query);

      const accounts = result?.response?.response?.accounts ?? {};
      const accountId = Object.keys(accounts)[0];
      const account = accounts[accountId] ?? {};
      const dates: any[] = this.normalizeToArray(account.dates);

      // Overall total from the response summary
      this.total =
        result?.response?.response?.all_account_cost_summary?.final_cost ?? 0;

      // Each "day" stands in for what used to be a "week" bucket.
      // weekKeys are now just indices into the dates array.
      this.weekKeys = dates.map((_: any, i: number) => String(i));
      this.weekHeaders = dates.map((d: any) => d.billing_period);

      // keep these around in case other code/templates reference them
      this.weeksObj = dates;
      this.market_weeksObj = dates;

      const allServiceCodes = new Set<string>();
      const marketAllServiceCodes = new Set<string>();

      dates.forEach((d: any) => {
        this.normalizeToArray(d.services).forEach((s: any) => {
          if (this.isMarketplace(s)) {
            marketAllServiceCodes.add(s.product_code);
          } else {
            allServiceCodes.add(s.product_code);
          }
        });
      });

      // Only expose marketplace day headers when marketplace items actually
      // exist somewhere in the range. Otherwise leave them empty so the
      // template's *ngIf falls through to the plain "No data found"
      // placeholder instead of rendering a full table with nothing in it.
      if (marketAllServiceCodes.size > 0) {
        this.market_weekKeys = this.weekKeys;
        this.market_weekHeaders = this.weekHeaders;
      } else {
        this.market_weekKeys = [];
        this.market_weekHeaders = [];
      }

      const buildTable = (
        codes: Set<string>,
        matches: (s: any) => boolean
      ): WeeklyPaginatedService[] =>
        Array.from(codes).map((code) => {
          const costs = dates.map((d: any, i: number) => {
            const s = this.normalizeToArray(d.services).find(
              (x: any) => x.product_code === code && matches(x)
            );
            return {
              week: String(i),
              base:
                s?.base_cost != null ? Number(s.base_cost).toFixed(2) : "-",
              final:
                s?.final_cost != null ? Number(s.final_cost).toFixed(2) : "-",
            };
          });

          // Region / product_family breakdown, when groupBy includes it.
          // NOTE: shape not yet confirmed against a sample response where
          // regions is non-empty — revisit field names if this is wrong.
          const regionMap = new Map<string, any>();
          dates.forEach((d: any, i: number) => {
            const s = this.normalizeToArray(d.services).find(
              (x: any) => x.product_code === code && matches(x)
            );
            this.normalizeToArray(s?.regions).forEach((r: any) => {
              if (!r?.region) return;
              const regionName = r.region.trim();

              if (!regionMap.has(regionName)) {
                regionMap.set(regionName, {
                  region: regionName,
                  costs: dates.map((_: any, wk: number) => ({
                    week: String(wk),
                    base: "-",
                    final: "-",
                  })),
                  product_families: [] as any[],
                  expanded: false,
                });
              }

              const regionData = regionMap.get(regionName);

              if (r.base_cost != null || r.final_cost != null) {
                regionData.costs[i] = {
                  week: String(i),
                  base:
                    r.base_cost != null ? Number(r.base_cost).toFixed(2) : "-",
                  final:
                    r.final_cost != null
                      ? Number(r.final_cost).toFixed(2)
                      : "-",
                };
              }

              const productFamilies = this.normalizeToArray(
                r.product_families
              );
              regionData.product_families = productFamilies.map(
                (pf: any) => ({
                  name: pf.product_family,
                  costs: dates.map((_: any, wk: number) => ({
                    week: String(wk),
                    base:
                      pf.base_cost != null
                        ? Number(pf.base_cost).toFixed(2)
                        : "-",
                    final:
                      pf.final_cost != null
                        ? Number(pf.final_cost).toFixed(2)
                        : "-",
                  })),
                })
              );
            });
          });

          return {
            // No separate product_name field in the new payload;
            // product_code is used for both.
            product_name: code,
            service_name: code,
            costs,
            regions: Array.from(regionMap.values()),
            expanded: false,
          };
        });

      this.servicesTable = buildTable(
        allServiceCodes,
        (s) => !this.isMarketplace(s)
      );
      this.market_servicesTable = buildTable(marketAllServiceCodes, (s) =>
        this.isMarketplace(s)
      );

      // Assign to filtered lists
      this.filteredList = this.servicesTable?.length
        ? [...this.servicesTable]
        : [];
      this.market_filteredList = this.market_servicesTable?.length
        ? [...this.market_servicesTable]
        : [];

      // No separate marketplace total field in the response summary yet,
      // so it's derived by summing marketplace line items across all days.
      this.market_total = dates.reduce((sum: number, d: any) => {
        const dayTotal = this.normalizeToArray(d.services)
          .filter((s: any) => this.isMarketplace(s))
          .reduce((s: number, x: any) => s + (x.final_cost || 0), 0);
        return sum + dayTotal;
      }, 0);

      const lastDay = dates[dates.length - 1];
      this.totactiveser = lastDay?.total_services ?? allServiceCodes.size;
      this.market_totactiveser =
        lastDay?.market_place_services ?? marketAllServiceCodes.size;

      // Graph for chart: each day's AWS services (normalized with a stable
      // `service`/`product_name` key, since the new API only gives
      // product_code) plus a synthetic "AWS Marketplace" line item
      // summarizing marketplace costs for that day.
      this.graph = dates.map((d: any) => {
        const dayServices = this.normalizeToArray(d.services);
        const marketDayTotal = dayServices
          .filter((s: any) => this.isMarketplace(s))
          .reduce((s: number, x: any) => s + (x.final_cost || 0), 0);

        const normalizedAwsServices = dayServices
          .filter((s: any) => !this.isMarketplace(s))
          .map((s: any) => ({
            ...s,
            // Stable identifiers for the chart, since the new API only
            // provides product_code (no separate `service` or
            // `product_name` field like the old one did).
            service: s.product_code,
            product_name: s.product_code,
            regions: this.normalizeToArray(s.regions),
          }));

        return {
          ...d,
          services: [
            ...normalizedAwsServices,
            marketDayTotal
              ? {
                  service: "AWS Marketplace",
                  billing_entity: "AWS Marketplace",
                  base_cost: marketDayTotal,
                  final_cost: marketDayTotal,
                  regions: [], // was `{}` — must match the array type used above
                  product_name: "AWS MarketPlace",
                }
              : null,
          ].filter(Boolean),
        };
      });

      // Emit monthly data
      this.monthlyData.emit({
        services: dates,
        total: this.total,
        totser: this.servicesTable.length,
      });
    } catch (err) {
      console.error("Error fetching data:", err);
      this.servicesTable = [];
      this.filteredList = [];
      this.weekHeaders = [];
      this.market_servicesTable = [];
      this.market_filteredList = [];
      this.market_weekHeaders = [];
      this.market_total = 0;
    } finally {
      this.notifier.loading(false);
    }
  }

  toggleExpandAll() {
    this.isExpandedAll = !this.isExpandedAll;
    this.monthexp.toggleWeeklyExpand(this.servicesTable, this.isExpandedAll);
    this.deepcopy();
    this.servicesTable.forEach(
      (s) => (this.productNameExpandedMap[s.service_name] = this.isExpandedAll)
    );
  }

  market_toggleExpandAll() {
    const newState = !this.market_isExpandedAll;
    this.monthexp.toggleWeeklyExpand(this.market_servicesTable, newState);
    this.deepcopy();

    // Use service_name as the key (same as template)
    this.market_servicesTable.forEach(
      (s) => (this.productNameExpandedMap[s.service_name] = newState)
    );

    this.market_isExpandedAll = newState;
  }

  productNameExpandedMap: { [key: string]: boolean } = {};

  // Toggle product name expand/collapse
  toggleProductName(product: WeeklyPaginatedService) {
    const isNowExpanded = !this.productNameExpandedMap[product.service_name];
    this.productNameExpandedMap[product.service_name] = isNowExpanded;

    // 🧹 When collapsing product, collapse its services
    if (!isNowExpanded) {
      product.expanded = false;
    }
  }

  // Check if product is expanded
  isProductNameExpanded(product: WeeklyPaginatedService): boolean {
    return !!this.productNameExpandedMap[product.service_name];
  }

  /**
   * Builds the query for the /admin/bills/dailyBilling endpoint:
   *   { accountId, startDate, endDate, groupBy }
   * startDate/endDate are the first and last calendar day of monthYear.
   */
  private baseParams(accountIds: string | string[]): Record<string, any> {
    const [month, year] = this.monthYear.split("-");
    const y = Number(year);
    const m = Number(month); // expected 1-12
    const pad = (n: number) => String(n).padStart(2, "0");

    const startDate = `${y}-${pad(m)}-01`;
    const lastDay = new Date(y, m, 0).getDate(); // last day of month m (1-indexed)
    const endDate = `${y}-${pad(m)}-${pad(lastDay)}`;

    return {
      // ASSUMPTION: endpoint takes a single accountId string, not an array.
      // If multi-account support is needed, this needs revisiting against
      // the real API contract.
      accountId: Array.isArray(accountIds) ? accountIds[0] : accountIds,
      startDate,
      endDate,
      // TODO: wire groupBy to preferencesData.breakpoints (region /
      // product_family / line_item) once the multi-level response shape
      // is confirmed. Hardcoded to SERVICE for now.
      groupBy: "SERVICE",
    };
  }

  async loadPreferences(filteredQuery: any): Promise<void> {
    this.filteredTag =
      filteredQuery?.tag_key && filteredQuery?.tag_value
        ? {
            accountId: filteredQuery.account_ids,
            tagKey: filteredQuery.tag_key,
            tagValue: filteredQuery.tag_value,
          }
        : null;
    const { mode, ...queryWithoutMode } = filteredQuery;

    await this.fetchAndBind(queryWithoutMode);

    if (mode) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { mode },
        queryParamsHandling: "merge",
        replaceUrl: true,
      });
    }
    this.searchSubscription = this.searchSubject
      .pipe(debounceTime(300))
      .subscribe((searchText) => {
        this.applyFilter(searchText);
      });

    this.market_searchSubscription = this.market_searchSubject
      .pipe(debounceTime(300))
      .subscribe((searchText) => {
        this.market_applyFilter(searchText);
      });

    this.deepcopy();
  }

  async load(): Promise<void> {
    const params = this.baseParams(this.accountId);
    params["type"] = this.selectedView;
    await this.fetchAndBind(params);
    this.searchSubscription = this.searchSubject
      .pipe(debounceTime(300))
      .subscribe((searchText) => {
        this.applyFilter(searchText);
      });
    this.market_searchSubscription = this.market_searchSubject
      .pipe(debounceTime(300))
      .subscribe((searchText) => {
        this.market_applyFilter(searchText);
      });
    // this.filteredList = [...this.servicesTable];
    this.deepcopy();
  }

  activeBreakpoints: any;

  handlePreferencesResponse(data: any) {
    this.gear = false;
    this.isExpandedAll = false;

    this.activeBreakpoints = Object.keys(
      data.preferences?.breakpoints ?? {}
    ).filter((key) => data.preferences.breakpoints[key]);

    if (data.preferences?.breakpointsChanged) {
      let params: Record<string, any> = {
        ...this.baseParams(this.accountId),
      };

      if (this.activeBreakpoints.length > 0) {
        params = {
          ...params,
          mode: "preferences",
          breakup: this.activeBreakpoints,
        };
      } else {
        const { mode, breakup, ...rest } = params;
        params = rest;
      }

      this.fetchAndBind(params);
    }

    if (data.preferences) {
      this.preferencesData = data.preferences;
      this.usagePagination = data.preferences.usagePagination;
      this.breakpoints = data.preferences.breakpoints;
      this.selectedAccountIds = data.preferences.selectedAccountIds;
    } else {
      console.log("No preferences found in response");
    }
    if (data.services) {
      this.filteredList = data.services.map(
        (s: any): WeeklyPaginatedService => ({
          product_name: s.product_name,
          service_name: s.serviceName, // convert Service.serviceName → WeeklyPaginatedService.service_name
          costs: s.costs || [],
          regions: (s.regions || []).map((r: any) => ({
            region: r.region,
            costs: r.costs || [],
            product_families: (r.product_families || []).map((pf: any) => ({
              name: pf.name || pf.product_family,
              costs: pf.costs || [],
            })),
            expanded: false,
          })),
          expanded: false,
        })
      );
    } else {
      this.filteredList = [];
    }

    this.currentPage = 1;
  }

  async onTagsFiltered({
    accountId,
    tagKey,
    tagValue,
  }: {
    accountId: any;
    tagKey: string;
    tagValue: string;
  }): Promise<void> {
    this.isExpandedAll = false;
    this.filteredTag = { accountId, tagKey, tagValue };
    this.preferencesData = this.getDefaultPreferences(accountId);

    const params = {
      ...this.baseParams(accountId),
      tag_key: tagKey,
      tag_value: tagValue,
      mode: "filter",
    };
    await this.fetchAndBind(params);
  }

  get marketPaginatedList() {
    return this.monthexp.paginate(
      this.market_filteredList,
      this.market_currentPage,
      this.market_selectedPageSize
    );
  }

  get paginatedList() {
    return this.monthexp.paginate(
      this.filteredList,
      this.currentPage,
      this.selectedPageSize
    );
  }

  get totalPages() {
    return this.monthexp.totalPages(this.filteredList, this.selectedPageSize);
  }

  goToNextPage() {
    this.currentPage = this.monthexp.nextPage(
      this.currentPage,
      this.totalPages
    );
  }

  goToPreviousPage() {
    this.currentPage = this.monthexp.prevPage(this.currentPage);
  }

  get marketTotalPages() {
    return this.monthexp.totalPages(
      this.market_filteredList,
      this.market_selectedPageSize
    );
  }

  marketNext() {
    this.market_currentPage = this.monthexp.nextPage(
      this.market_currentPage,
      this.marketTotalPages
    );
  }

  marketPrev() {
    this.market_currentPage = this.monthexp.prevPage(this.market_currentPage);
  }

  clearTagFilter() {
    this.filteredTag = null;
    this.preferencesData = this.getDefaultPreferences();
    this.load();
  }

  toggle(item: any) {
    item.expanded = !item.expanded;
  }

  searchSubject: Subject<string> = new Subject<string>();
  searchSubscription!: Subscription;

  market_searchSubject: Subject<string> = new Subject<string>();
  market_searchSubscription!: Subscription;

  onSearch() {
    this.searchSubject.next(this.searchTerm);
  }

  market_onSearch() {
    this.market_searchSubject.next(this.market_searchTerm);
  }

  private filterServices(
    list: WeeklyPaginatedService[],
    text: string
  ): WeeklyPaginatedService[] {
    const filterText = text.trim().toLowerCase();
    if (!filterText) return [...list];

    return list.filter(
      (s) =>
        (s.service_name || "").toLowerCase().includes(filterText) ||
        (s.product_name || "").toLowerCase().includes(filterText)
    );
  }

  applyFilter(text: string) {
    this.filteredList = this.filterServices(this.servicesTable, text);
  }

  market_applyFilter(text: string) {
    this.market_filteredList = this.filterServices(
      this.market_servicesTable,
      text
    );
  }

  trackByService(index: number, item: WeeklyPaginatedService): string {
    return item.service_name;
  }

  private getDefaultPreferences(accountIds: any[] = []): any {
    return {
      pageSize: 20,
      wrapLines: false,
      usagePagination: true,
      visibleColumns: {
        description: true,
        usageQuantity: true,
        amountUsd: true,
      },
      breakpoints: {
        region: false,
        product_family: false,
        line_item: false,
      },
      selectedAccountIds: accountIds,
    };
  }

  onViewChange() {
    this.load();
  }
}